export default function WhatsappIcon({
  size = 'w-[26px] h-[26px]',
  color = 'white',
}) {
  return (
    <svg
      className={size}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66087 17.9471C3.4583 15.9182 3.03766 13.5201 3.47791 11.203C3.91816 8.88596 5.18902 6.80926 7.05192 5.36279C8.91482 3.91633 11.2416 3.19957 13.5955 3.34709C15.9494 3.49461 18.1686 4.49626 19.8363 6.16399C21.504 7.83172 22.5057 10.0508 22.6532 12.4048C22.8007 14.7587 22.084 17.0855 20.6375 18.9484C19.191 20.8113 17.1143 22.0821 14.7973 22.5224C12.4802 22.9626 10.0821 22.542 8.05317 21.3394V21.3394L4.70125 22.2885C4.56392 22.3286 4.41831 22.3311 4.27969 22.2957C4.14107 22.2602 4.01454 22.1881 3.91337 22.0869C3.81219 21.9857 3.7401 21.8592 3.70464 21.7206C3.66918 21.582 3.67166 21.4364 3.71183 21.299L4.66087 17.9471Z"
        stroke={color}
        strokeWidth="0.807692"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4332 18.6539C14.3705 18.6565 13.3177 18.4492 12.3353 18.0437C11.3529 17.6382 10.4604 17.0427 9.70888 16.2912C8.9574 15.5397 8.36182 14.6471 7.95635 13.6648C7.55088 12.6824 7.34352 11.6296 7.34619 10.5668C7.34886 9.81885 7.64787 9.10241 8.17773 8.57444C8.7076 8.04647 9.42511 7.75002 10.1731 7.75002V7.75002C10.2965 7.74904 10.4179 7.78134 10.5245 7.84352C10.6311 7.90571 10.719 7.99548 10.7789 8.10339L11.9601 10.163C12.0304 10.2882 12.0664 10.4297 12.0647 10.5732C12.0629 10.7168 12.0233 10.8574 11.95 10.9808L11.001 12.5659C11.4871 13.6473 12.3528 14.513 13.4342 14.9991L15.0193 14.05C15.1427 13.9767 15.2833 13.9372 15.4268 13.9354C15.5704 13.9336 15.7118 13.9697 15.8371 14.0399L17.8967 15.2212C18.0046 15.2811 18.0943 15.3689 18.1565 15.4755C18.2187 15.5821 18.251 15.7035 18.25 15.8269C18.2474 16.5741 17.9501 17.2901 17.4227 17.8194C16.8953 18.3487 16.1804 18.6486 15.4332 18.6539V18.6539Z"
        stroke={color}
        strokeWidth="0.807692"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
